module.exports = __webpack_public_path__ + "img/text-size.2f9ada2d.svg";